<template>
    <p class="voucher-counter">
        {{labels.counterVoucher}} {{voucherNumber}}: {{freeSamples}} {{labels.counterOutOf}} {{totalSamples}} {{labels.counterAreAvailable}}
    </p>
</template>

<script>
import { Config, Labels} from "../services.js";

export default {
    name: "VoucherCounter",
    props: {
        voucherNumber: String,
        freeSamples: Number,
        totalSamples: Number
    },
    data() {
        return {
            labels: Labels,
            config: Config
        }
    },
}
</script>

<style scoped>
.voucher-counter {
    font-size: 18px;
    margin: 20px 0px;
    padding: 10px;
    background-color: rgba(254,248,198,0.7);
    border: 1px solid yellow;
    text-align: center;
}
</style>
